import { type Address } from '../types/Address';

export const stringifyAddress = ({
  city,
  state,
  streetAddress,
  zip,
}: Address): string => {
  return [streetAddress, city, state, zip].filter((value) => value).join(', ');
};
